export function addPlural(word: string, quantity = 0): string {
  return quantity > 1 ? `${word}s` : word
}
